import { webApiWithResponse } from "../../../../core/http/httpThunks";
import { EditOrder } from "../types";

export const updateOrderApi = (order: EditOrder, userid: string) =>
  webApiWithResponse<string>({
    method: "PUT",
    url: "order/updorder",
    data: order,
    params: {
      userid
    }
  });

export default updateOrderApi;
